import type { SaveSessionFeedbackInput, SessionFeedbackForm, SessionFeedbackResponse } from '@conference/shared';
import { apiClient } from './apiClient';

export const sessionFeedbackService = {
  getForm: (sessionId: string, signal?: AbortSignal) =>
    apiClient.get<SessionFeedbackForm>(`/sessions/${sessionId}/feedback`, { signal }),
  save: (sessionId: string, input: SaveSessionFeedbackInput, signal?: AbortSignal) =>
    apiClient.put<SessionFeedbackResponse>(`/sessions/${sessionId}/feedback`, input, { signal }),
  getPresentationForm: (paperId: string, signal?: AbortSignal) =>
    apiClient.get<SessionFeedbackForm>(`/papers/${paperId}/feedback`, { signal }),
  savePresentation: (paperId: string, input: SaveSessionFeedbackInput, signal?: AbortSignal) =>
    apiClient.put<SessionFeedbackResponse>(`/papers/${paperId}/feedback`, input, { signal }),
};
